<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            Structural Design Pattern
          </h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <img
            src="../../../../assets/resources/whitepaper/structuraldesignpattern/structural-design-pattern-bannerimg.gif"
            alt="Structural Design Pattern" class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Structural design patterns define efficient ways to compose classes and objects, enabling scalable and
          maintainable software systems.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>These patterns focus on simplifying complex architectures while maintaining flexibility and reusability.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Common structural patterns include Adapter, Bridge, Composite, Decorator, Facade, Flyweight, and Proxy, each
          solving a specific architectural challenge.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Applying structural design patterns helps integrate legacy systems, optimize memory usage, and manage object
          relationships effectively.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>They are essential for building enterprise-grade, extensible, and performance-optimized applications.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Understanding these patterns improves software quality, long-term maintainability, and development
          efficiency.</p>
      </div>
    </div>
  </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Key Takeaways</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Adapter Design Pattern enables seamless integration of incompatible interfaces, especially useful for legacy
          systems and third-party libraries.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Bridge Design Pattern decouples abstraction from implementation, allowing independent evolution and reducing
          class explosion.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Composite Design Pattern supports tree structures, enabling uniform treatment of individual objects and
          object compositions.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Decorator Design Pattern allows dynamic behavior extension without modifying existing class structures.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Facade Design Pattern simplifies interaction with complex subsystems through a unified, easy-to-use
          interface.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Flyweight Design Patterns and Proxy Design Patterns improve performance by optimizing memory usage and
          controlling access to resource-intensive objects.</p>
      </div>
    </div>
    <button class="btn case-study-btn" (click)="openModal()">
      <i class="ri-download-2-line"></i> Download the Complete White Paper
    </button>
  </div>
</section>
<!-- Relavent Article -->
<app-relevant-whitepaper></app-relevant-whitepaper>

<!-- MODAL POPUP -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content-box">
    <button class="close-btn" (click)="closeModal()">&times;</button>

    <div class="modal-header" *ngIf="!submitSuccess">
      <h3>Download White Paper</h3>
      <p>Fill in your details to receive the white paper.</p>
    </div>

    <div *ngIf="submitSuccess" class="success-message text-center">
      <i class="ri-checkbox-circle-fill" style="color: #28a745; font-size: 3rem;"></i>
      <h4>Thank you!</h4>
      <p>Check your email for the download link.</p>
      <small style="color: #666;">Please check your spam folder if you don't see it.</small>
    </div>

    <form [formGroup]="downloadForm" (ngSubmit)="onSubmit()" *ngIf="!submitSuccess">
      <div class="form-group">
        <label>Full Name</label>
        <input type="text" formControlName="name" class="form-control" placeholder="Name">
        <div class="error-msg" *ngIf="downloadForm.get('name')?.touched && downloadForm.get('name')?.errors">

          <span *ngIf="downloadForm.get('name')?.errors?.['required']">
            Name is required
          </span>

          <span *ngIf="downloadForm.get('name')?.errors?.['pattern']">
            Name should contain only letters
          </span>

        </div>
      </div>

      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email" class="form-control" placeholder="Email">
        <div class="error-msg" *ngIf="downloadForm.get('email')?.touched && downloadForm.get('email')?.errors">

          <span *ngIf="downloadForm.get('email')?.errors?.['required']">
            Email is required
          </span>

          <span *ngIf="downloadForm.get('email')?.errors?.['pattern']">
            Enter a valid email address
          </span>

        </div>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="modal-footer">
        <button type="submit" class="submit-btn" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Processing...' : 'Download Now' }}
        </button>
      </div>
    </form>
  </div>
</div>